module.exports = __webpack_public_path__ + "assets/img/banner.83df5f63.png";